export const environment = {
  production: false,
  apiUrl: 'https://api.srivigneshwarajewellery.com'
};